import { render } from "./InnerLayout.vue?vue&type=template&id=6b90a2be&scoped=true"
import script from "./InnerLayout.vue?vue&type=script&lang=js"
export * from "./InnerLayout.vue?vue&type=script&lang=js"

import "./InnerLayout.vue?vue&type=style&index=0&id=6b90a2be&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b90a2be"]])

export default __exports__